angular
    .module('empower.control')
    .directive('alphanum', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var defaultOption = {
                    allow: '!"#$%&\'()*+,-./:;=?@[\\]^_`{|}~',
                    allowCaseless: true,
                    allowOtherCharSets: false,
                    allowNumeric: true
                };
                if (!!attrs.allowSpecial) {
                    defaultOption.allow = attrs.allowSpecial;
                }
                $(element).alphanum(defaultOption);
                //Update modelvalue
                ctrl.$parsers.unshift(function (viewValue) {
                    scope.ngModel = viewValue;
                    return viewValue;
                });
            }
        };
    })
    .directive('numericOnly', function () {
        return {
            require: '?ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (inputValue) {
                    if (inputValue == undefined) return '';
                    var transformedInput = inputValue.replace(/[^0-9]/g, '');
                    if (transformedInput !== inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }
                    return transformedInput;
                });
            }
        };
    })
    .directive('decimalOnly', function () {
        return {
            link: function (scope, element) {
                $(element).numeric({
                    allowMinus: false,
                    allowThouSep: false,
                    maxDigits: 14,
                    maxDecimalPlaces: 2,
                    maxPreDecimalPlaces: 11
                });
            }
        };
    })

    // Validate input - prevent user type invalid input (regex from ng-pattern)
    .directive("validateRegexInput", function () {
        return {
            restrict: "A",
            scope: {},
            replace: false,
            link: function (scope, element, attrs, ctrl) {
                element.bind('keypress', function (event) {
                    var regex = new RegExp(attrs.ngPattern);
                    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
                    if (!regex.test(key)) {
                        event.preventDefault();
                        return false;
                    }
                });
            }
        };
    })
    .directive('policyNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var defaultOption = {
                    allow: '-',
                    allowCaseless: true,
                    allowOtherCharSets: false,
                    allowNumeric: true
                };
                if (!!attrs.allowSpecial) {
                    defaultOption.allow = attrs.allowSpecial;
                }
                $(element).alphanum(defaultOption);
                //Update modelvalue
                ctrl.$parsers.unshift(function (viewValue) {
                    scope.ngModel = viewValue;
                    return viewValue;
                });
            }
        };
    })
    .directive('convertToNumber', function() {      //fix <select> not select correct option if value is number type 
        return {
          require: 'ngModel',
          link: function(scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function(val) {
              return parseInt(val, 10);
            });
            ngModel.$formatters.push(function(val) {
              return '' + val;
            });
          }
        };
      });
    
